import { BillStatus, TransactionStatus, UserOrganizationRole } from "../../API";

// Mirror of the app's per-row edit gate (transactions_list.dart:206-216):
// a draft is never editable (it is pending its Bexio sync); accountants and
// admins may edit anything else; everyone else may edit unless the transaction
// sits on a paid bill. `bill?.status` compares unequal to paid when the bill
// is null OR redacted by AppSync field auth (Bill carries no head-read rule) —
// both fall open to editable, exactly like the Dart's null-safe `?.`.
export const isTransactionEditingEnabled = (
  transaction: {
    status: TransactionStatus;
    bill?: { status: BillStatus } | null;
  },
  userOrganizationRole: UserOrganizationRole | undefined
): boolean =>
  transaction.status !== TransactionStatus.draft &&
  (userOrganizationRole === UserOrganizationRole.accountant ||
    userOrganizationRole === UserOrganizationRole.admin ||
    transaction.bill?.status !== BillStatus.paid);
